import { render } from "./AgregarAdministrador.vue?vue&type=template&id=08a74d81&scoped=true"
import script from "./AgregarAdministrador.vue?vue&type=script&lang=js"
export * from "./AgregarAdministrador.vue?vue&type=script&lang=js"

import "./AgregarAdministrador.vue?vue&type=style&index=0&id=08a74d81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a74d81"]])

export default __exports__